export default __webpack_public_path__ + "static/DMSans-SemiBold-86d8f788fadd3063e7b87041a391094d.ttf";